module.exports = __webpack_public_path__ + "static/media/side-border-right-bottom.2b71eef1.svg";